import { useEffect } from "react";

// Preload critical pages after initial render
const preloadPages = () => {
  // Most visited pages - preload after 2 seconds
  const criticalPages = [
    () => import("@/pages/Index"),
    () => import("@/pages/OrderExtrasCF"),
    () => import("@/pages/CalificareCredit"),
  ];

  // Preload critical pages
  setTimeout(() => {
    criticalPages.forEach((importFn) => {
      importFn().catch(() => {
        // Silent fail - preloading is optional
      });
    });
  }, 2000);
};

export const usePagePreload = () => {
  useEffect(() => {
    // Only preload if connection is good
    const connection = (navigator as any).connection;
    if (connection) {
      const { effectiveType, saveData } = connection;
      // Don't preload on slow connections or data saver mode
      if (effectiveType === "2g" || effectiveType === "slow-2g" || saveData) {
        return;
      }
    }

    // Preload after initial page is interactive
    if ("requestIdleCallback" in window) {
      (window as any).requestIdleCallback(preloadPages);
    } else {
      preloadPages();
    }
  }, []);
};

// Utility to preload a specific page on hover
export const preloadOnHover = (importFn: () => Promise<any>) => {
  let preloaded = false;
  
  return {
    onMouseEnter: () => {
      if (!preloaded) {
        preloaded = true;
        importFn().catch(() => {});
      }
    },
    onTouchStart: () => {
      if (!preloaded) {
        preloaded = true;
        importFn().catch(() => {});
      }
    },
  };
};
